import React from 'react';

import PropTypes from 'prop-types';

import { Stack, Typography } from '@gogame/components';

import AttributeContext from './AttributeContext';

const AttributeList = ({
  children,
  type = 'label',
  variant = 'standard',
  typographyVariant = 'overline',
  typographyColor,
  color,
  listSeparator,
  direction = 'row',
  justifyContent,
  alignItems = 'center',
  spacing = 1,
  flexWrap,
  p,
}) => {
  return (
    <AttributeContext.Provider
      value={{ type, variant, color, typographyVariant, typographyColor }}
    >
      <Stack
        color={color}
        direction={direction}
        alignItems={alignItems}
        justifyContent={justifyContent}
        flexWrap={flexWrap}
        spacing={spacing}
        p={p}
      >
        {listSeparator
          ? React.Children.toArray(children).reduce(
              (prev, curr, i) =>
                prev !== null
                  ? [
                      ...prev,
                      <Typography key={i} variant={typographyVariant}>
                        {listSeparator}
                      </Typography>,
                      curr,
                    ]
                  : [curr],
              null
            )
          : children}
      </Stack>
    </AttributeContext.Provider>
  );
};

AttributeList.propTypes = {
  type: PropTypes.oneOf(['icon', 'label', 'text']),
  variant: PropTypes.oneOf(['standard', 'outlined', 'chips']),
  color: PropTypes.string,
  typographyVariant: PropTypes.string,
  typographyColor: PropTypes.string,
  listSeparator: PropTypes.string,
  spacing: PropTypes.number,
  p: PropTypes.number,
};

export default AttributeList;
